// extracted by mini-css-extract-plugin
export default {"editButton":"salaryHold_editButton__x6nV8","TableBody":"salaryHold_TableBody__+g6yJ"};